{
  "notFoundTitle": "Page not found",
  "notFoundBody": "This auction lot doesn't exist or has been withdrawn.",
  "backToAuctions": "Back to auctions",
  "genericTitle": "Something went wrong",
  "genericBody": "Please try again or head home.",
  "goHome": "Go home",
  "offline": "You appear to be offline.",
  "emptyTitle": "Nothing to show yet.",
  "loadFailed": "We couldn't load this right now.",
  "tryAgain": "Try again",
  "routeErrorTitle": "Something went wrong",
  "routeErrorBody": "We couldn't load this page right now. Please try again — if the problem persists you can head back or return home.",
  "retry": "Retry",
  "back": "Back",
  "notFound404": "404",
  "notFoundHeading": "Page not found",
  "notFoundDetail": "The page you're looking for doesn't exist or may have been moved.",
  "home": "Home",
  "searchAuctions": "Search auctions",
  "retrying": "Retrying…"
}
